import { useRef, useState, useEffect } from 'react';

export interface UseTimerPayload {
  unixDeadline: number;
  interval?: number;
  onEnd?: () => void;
}

const SECOND = 1000;

const getDiff = (to: number) => {
  const diff = to - Date.now();

  return diff > 0 ? diff : 0;
};

export const useTimer = ({
  unixDeadline,
  interval = SECOND,
  onEnd,
}: UseTimerPayload) => {
  const intervalRef = useRef<number | null>(null);
  const [timeSpan, setTimeSpan] = useState(getDiff(unixDeadline));
  const timeSpanRef = useRef<number>(getDiff(unixDeadline));

  const resetInterval = () => {
    intervalRef.current && clearInterval(intervalRef.current);
  };

  useEffect(() => {
    if (!unixDeadline) return;

    const diff = getDiff(unixDeadline);

    setTimeSpan(diff);
    timeSpanRef.current = diff;

    resetInterval();

    // Do not event try start the timer if the diff is 0
    if (!diff) {
      onEnd?.();
      return;
    }

    intervalRef.current = window.setInterval(() => {
      const curr = timeSpanRef.current;
      const next = curr - 1000;

      if (next < 0) {
        onEnd?.();
        resetInterval();
        return;
      }

      timeSpanRef.current = next;
      setTimeSpan(next);
    }, interval);

    return () => {
      resetInterval();
    };
  }, [unixDeadline, interval, onEnd]);

  return timeSpan;
};
